import { useMutation } from '@tanstack/react-query';

import API from '@api/API';

export const useUpdateEventImageMutation = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: ({ eventId, imageFromEventId }: { eventId: string; imageFromEventId: string }) =>
      API.post<{ eventId: string }, { imageFromEventId: string }>(
        `/v1/super-admin/events/${eventId}/image`,
        { imageFromEventId },
      ),
  });

  return {
    isUpdatingEventImage: isPending,
    updateEventImageAsync: mutateAsync,
  };
};
